/* GENERATED — do not edit.
   Source: clients/profit_minded/site_rebuild/_gen_mockups.py CART_JS + PREFETCH_JS (mock stripped)
   Regenerate: python clients/profit_minded/theme_variant_a/_derive_assets.py */
/* ===== pm-cart.js ==========================================================
   Ports to assets/pm-cart.js unchanged except for ONE function (see NETWORK
   BOUNDARY below). Everything it reads comes from the DOM: the free-shipping
   threshold from a data-* attribute in cents, copy from an application/json
   blob, and the initial cart from {{ cart | json }}.

   State shape mirrors /cart.js exactly, plus two transient fields:
     _loading  set on optimistic mutate, cleared on server ack
     _error    sticky; cleared only by a retry that succeeds
   ========================================================================= */
(function () {
  var root = document.querySelector('[data-pm-drawer]');
  if (!root) return;

  var THRESHOLD = parseInt(document.body.getAttribute('data-pm-freeship-threshold') || '0', 10);
  var DEBOUNCE  = 350;

  var STR  = JSON.parse(document.querySelector('[data-pm-cart-strings]').textContent);
  var CART = JSON.parse(document.querySelector('[data-pm-cart-state]').textContent);

  var elLines = root.querySelector('[data-pm-lines]');
  var elEmpty = root.querySelector('[data-pm-empty]');
  var elFoot  = root.querySelector('[data-pm-drawer-foot]');
  var elCount = root.querySelector('[data-pm-drawer-count]');
  var elSub   = root.querySelector('[data-pm-subtotal]');
  var elShip     = root.querySelector('[data-pm-ship]');
  var elShipMsg  = root.querySelector('[data-pm-ship-msg]');
  var elShipFill = root.querySelector('[data-pm-ship-fill]');
  var panel   = root.querySelector('.pm-drawer__panel');

  /* ---- the /cart page, when we are on it (all null elsewhere) ---- */
  var pageRoot   = document.querySelector('[data-pm-cartpage]');
  var pgLines    = pageRoot && pageRoot.querySelector('[data-pm-page-lines]');
  var pgEmpty    = pageRoot && pageRoot.querySelector('[data-pm-page-empty]');
  var pgForm     = pageRoot && pageRoot.querySelector('[data-pm-page-form]');
  /* The empty/populated toggle is the GRID, not the form: the server renders
     `hidden` on the grid, so the JS must toggle that same element or a cart that
     fills via JS un-hides the form around a grid that stays hidden. */
  var pgGrid     = pageRoot && pageRoot.querySelector('[data-pm-page-grid]');
  var pgCount    = pageRoot && pageRoot.querySelector('[data-pm-page-count]');
  var pgSub      = pageRoot && pageRoot.querySelector('[data-pm-page-subtotal]');
  var pgSide     = pageRoot && pageRoot.querySelector('[data-pm-page-side]');
  var pgCheckout = pageRoot && pageRoot.querySelector('[data-pm-page-checkout]');
  var pgDisc     = pageRoot && pageRoot.querySelector('[data-pm-page-discount]');
  var pgDiscV    = pageRoot && pageRoot.querySelector('[data-pm-page-discount-value]');
  var pgShipMsg  = pageRoot && pageRoot.querySelector('[data-pm-page-ship-msg]');
  var pgShipFill = pageRoot && pageRoot.querySelector('[data-pm-page-ship-fill]');

  /* Number of mutations in flight, INCLUDING the debounce window. Checkout is
     blocked while this is non-zero — a shopper who steps a quantity and taps
     checkout inside DEBOUNCE ms would otherwise check out the pre-change cart. */
  var busyCount = 0;

  /* Set from JS, deliberately NOT from an inline <head> script. The class gates the
     no-JS update button away and reveals the +/- steppers, so it must mean "the cart
     script is actually running", not "scripts are enabled". Setting it in <head>
     would hide the working fallback even when this file fails to load, leaving the
     cart page with no usable quantity control at all. The cost is a brief flash of
     the UPDATE button on a slow connection, which is the correct trade. */
  document.documentElement.classList.add('pm-js');

  /* ===== THE ONLY NETWORK BOUNDARY ==========================================
     Every request this file makes goes through api(). Keep it that way: the
     mockup's fake transport was removed here at port time and not one other
     function had to change, which is the property that made the port safe.
     ========================================================================= */
  function api(path, body) {
    var opts = { headers: { 'Accept': 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(path, opts).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          throw new Error(j.description || ('HTTP ' + r.status));
        });
      }
      return r.json();
    });
  }

  /* ===== ONE ROUND TRIP PER ADD =============================================
     Derrick 2026-09-11: "make sure it's not making a bunch of round trips for
     everything." Counted on the wire, only the add was doubled:

         add to bag    POST /cart/add.js  then  GET /cart.js    438 + 192 ms
         quantity +1   POST /cart/change.js                     one trip, returns
                                                                the whole cart

     The second request existed because /cart/add.js replies with the LINE ITEM it
     added and carries no totals — measured on this store, its only top-level keys
     are `items` and `sections`. The subtotal and the free-shipping bar need
     total_price and item_count, so the code had to go and ask for them.

     Shopify's mechanism for this is Bundled Section Rendering: name a section in the
     request and its rendered output comes back in the same response. sections/
     pm-cart-json.liquid is a section that emits nothing but {{ cart | json }}, wired
     into the footer group so it exists on every page — which is what makes it
     addressable. One request now carries both the add and the resulting cart.

     THE FALLBACK IS NOT OPTIONAL. If the section is missing, disabled, renders empty
     (which is exactly what a snippet-not-a-section returns), or fails to parse, this
     falls through to GET /cart.js. A theme edit or a Shopify change must degrade to
     what shipped before this — slower by 192 ms — and never to a broken cart.

     `sections_url` is location.pathname WITHOUT the query string: Shopify renders the
     section in the context of that URL, and pathname alone is the stable, cacheable
     form. Cart totals do not vary by query string.

     In the mockup this deliberately takes the fallback: the fake transport returns no
     `sections` key, so cartFromSections() returns null and the cart comes from
     /cart.js. That means the mockup exercises the degraded path on every add, which is
     the path most likely to rot unnoticed.
     ========================================================================= */
  var CART_SECTION = 'pm-cart-json';

  function cartFromSections(payload) {
    var html = payload && payload.sections && payload.sections[CART_SECTION];
    if (!html) return null;
    try {
      var host = document.createElement('div');
      host.innerHTML = html;
      var node = host.querySelector('[data-pm-cart-json]');
      if (!node) return null;
      var cart = JSON.parse(node.textContent);
      /* Shape check, not a truthiness check. An empty object would sail through a
         `!cart` test and then blow up adopt() with an undefined items array. */
      if (!cart || !Array.isArray(cart.items) || typeof cart.total_price !== 'number') return null;
      return cart;
    } catch (e) {
      return null;
    }
  }

  function addOnce(variantId, n) {
    return api('/cart/add.js', {
      items: [{ id: variantId, quantity: n }],
      sections: CART_SECTION,
      sections_url: location.pathname
    }).then(function (payload) {
      return cartFromSections(payload) || api('/cart.js');
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function find(key) {
    for (var i = 0; i < CART.items.length; i++) if (CART.items[i].key === key) return CART.items[i];
    return null;
  }
  function recalc() {
    var n = 0, t = 0;
    CART.items.forEach(function (l) {
      l.final_line_price = l.price * l.quantity;
      n += l.quantity; t += l.final_line_price;
    });
    CART.item_count = n; CART.total_price = t;
  }
  /* Adopt a server cart as the new truth, but do not silently swallow a sticky
     error on some OTHER line just because this line succeeded. */
  function adopt(cart) {
    var errs = {};
    CART.items.forEach(function (l) { if (l._error) errs[l.key] = true; });
    CART = cart;
    CART.items.forEach(function (l) {
      l._loading = false;
      if (errs[l.key]) l._error = true;
    });
  }

  /* ONE line renderer for BOTH hosts. `forPage` only decides whether the quantity
     input carries name="updates[]" — the cart page's no-JS fallback submits the whole
     bag through {% form 'cart' %}, where Shopify maps that array BY CART-LINE ORDER,
     and a stray updates[] inside the drawer would be a form field with no form.
     Everything else is byte-identical on purpose: the drawer and the page must not be
     able to drift, and a product should look the same wherever a shopper meets it. */
  function lineHTML(l, forPage) {
    /* An empty image would have produced src="?width=160" — a request for the CURRENT
       PAGE, rendered as a broken image. Render no <img> at all instead; the frame keeps
       its ratio and reads as a placeholder. */
    var frame = '';
    if (l.image) {
      var w = forPage ? 240 : 160;
      frame = '<img src="' + esc(String(l.image).split('?')[0] + '?width=' + w) +
              '" alt="" width="' + (forPage ? 120 : 64) + '" height="' +
              (forPage ? 150 : 80) + '" loading="lazy">';
    }
    /* 'Default Title' is Shopify's placeholder for a product with NO options. The
       Liquid first paint already suppressed it; this path did not, so it appeared the
       moment any cart mutation re-rendered the line. */
    var vt = (l.variant_title && l.variant_title !== 'Default Title') ? l.variant_title : '';
    return '<li class="pm-line" data-pm-line data-key="' + esc(l.key) + '" data-loading="' +
      (l._loading ? 'true' : 'false') + '">' +
      '<div class="pm-line__frame">' + frame + '</div>' +
      '<div class="pm-line__body">' +
        '<a class="pm-line__title t-product" href="' + esc(l.url) + '">' + esc(l.product_title) + '</a>' +
        (vt ? '<span class="pm-line__opt t-price">' + esc(vt) + '</span>' : '') +
        '<div class="pm-line__row">' +
          '<span class="pm-qty">' +
            '<button type="button" class="t-nav" data-pm-qty-dec aria-label="Decrease quantity">&minus;</button>' +
            '<input class="t-price" type="number" inputmode="numeric" min="0" value="' + l.quantity +
              '"' + (forPage ? ' name="updates[]"' : '') + ' data-pm-qty-input aria-label="Quantity">' +
            '<button type="button" class="t-nav" data-pm-qty-inc aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<span class="t-price" data-pm-line-total>' + money(l.final_line_price) + '</span>' +
        '</div>' +
        '<div class="pm-line__row">' +
          '<button type="button" class="pm-line__remove t-label" data-pm-line-remove>Remove</button>' +
        '</div>' +
        (l._error ? '<p class="pm-line__err t-label">' + esc(STR.line_error) + '</p>' : '') +
      '</div></li>';
  }

  function render() {
    var n = CART.item_count, empty = n === 0;
    root.setAttribute('data-empty', empty ? 'true' : 'false');
    elCount.textContent = n ? '(' + n + ')' : '';
    [].forEach.call(document.querySelectorAll('[data-pm-bag-count]'), function (b) {
      b.textContent = n;
      b.setAttribute('data-empty', empty ? 'true' : 'false');
    });
    /* The empty state is NOT manifested by JS — it is server-rendered and only
       toggled here, so first paint and every later paint agree. */
    elEmpty.hidden = !empty;
    elLines.hidden = empty;
    elFoot.hidden = empty;
    elShip.hidden = empty;
    /* NOT `.map(lineHTML)`. Array.map passes (value, INDEX, array), so the index
       would arrive as lineHTML's second argument — falsy for line 0 and truthy for
       every line after it, which would silently grow a name="updates[]" field on
       drawer lines 2..n. Wrap, always, when the callback takes optional params. */
    elLines.innerHTML = CART.items.map(function (l) { return lineHTML(l, false); }).join('');
    elSub.textContent = money(CART.total_price);
    ship();
    syncUpsell();
    renderPage();
  }

  /* ===== the /cart page =====================================================
     Painted from the SAME CART object and inside the SAME render() call as the
     drawer, so the two can never disagree. B-047's recorded failure was a shared
     line snippet whose JS only ever re-rendered the drawer's host: opening the
     drawer over /cart and stepping a quantity there mutated the cart while the
     page behind it kept showing the old numbers.
     ========================================================================= */
  function renderPage() {
    if (!pageRoot) return;
    var n = CART.item_count, empty = n === 0;
    pageRoot.setAttribute('data-empty', empty ? 'true' : 'false');
    if (pgEmpty) pgEmpty.hidden = !empty;
    if (pgGrid) pgGrid.hidden = empty;
    if (pgCount) pgCount.textContent = n ? '(' + n + ')' : '';
    if (pgLines) {
      pgLines.innerHTML = CART.items.map(function (l) { return lineHTML(l, true); }).join('');
    }
    if (pgSub) pgSub.textContent = money(CART.total_price);
    /* Server truth only. total_discount is whatever the server last told us; the
       optimistic path cannot compute it (two automatic discounts are active on this
       store and a BXGY can split a line), so the row is hidden rather than guessed. */
    if (pgDisc) {
      var d = CART.total_discount || 0;
      pgDisc.hidden = !(d > 0) || busyCount > 0;
      if (d > 0 && pgDiscV) pgDiscV.textContent = '-' + money(d);
    }
    if (pgShipMsg && THRESHOLD) {
      var rem = Math.max(0, THRESHOLD - CART.total_price);
      pgShipMsg.textContent = rem === 0 ? STR.freeship_reached
        : STR.freeship_progress.replace('{amount}', money(rem));
      if (pgShipFill) {
        pgShipFill.style.width =
          Math.min(100, Math.round(CART.total_price / THRESHOLD * 100)) + '%';
      }
    }
    syncBusy();
  }

  /* Checkout must not fire against a cart the server has not caught up with — a
     debounced quantity change is still in flight for up to DEBOUNCE ms plus a round
     trip. On the page this is a real <button disabled>, which the browser enforces.
     The DRAWER's checkout is an <a>, and a "disabled" link stays keyboard-activatable
     however much aria you put on it, so it is taken OUT of the tab order and its
     activation is guarded in the click handler too. */
  function syncBusy() {
    var busy = busyCount > 0;
    if (pgSide) pgSide.setAttribute('data-busy', busy ? 'true' : 'false');
    if (pgCheckout) pgCheckout.disabled = busy;
    [].forEach.call(document.querySelectorAll('.pm-checkout'), function (a) {
      a.setAttribute('aria-disabled', busy ? 'true' : 'false');
      if (busy) a.setAttribute('tabindex', '-1');
      else a.removeAttribute('tabindex');
    });
  }

  function ship() {
    if (!THRESHOLD || !elShipMsg) return;
    var remaining = Math.max(0, THRESHOLD - CART.total_price);
    elShipMsg.textContent = remaining === 0
      ? STR.freeship_reached
      : STR.freeship_progress.replace('{amount}', money(remaining));
    elShipFill.style.width = Math.min(100, Math.round(CART.total_price / THRESHOLD * 100)) + '%';
  }

  /* ---- mutations ---- */
  var timers = {}, pending = {};
  function setQty(key, qty) {
    var line = find(key);
    if (!line) return;
    var prev = line.quantity;
    if (qty < 0) qty = 0;
    line.quantity = qty;
    line._loading = true;
    line._error = false;
    /* One increment per KEY, held across the debounce until the request settles.
       Incrementing per CALL would leak: clearTimeout cancels the send, not the
       counter, so a shopper tapping + five times would leave busyCount at 5 and
       checkout disabled forever. */
    if (!pending[key]) { pending[key] = true; busyCount++; }
    recalc(); render();

    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      /* Clear the flag BEFORE the paint that consumes it (SKILL trap #16): render()
         reads busyCount to decide whether checkout is enabled, so decrementing after
         the repaint would leave the button disabled until some unrelated cart event
         repainted it. Both paths below clear first, then render. */
      api('/cart/change.js', { id: key, quantity: qty }).then(function (cart) {
        adopt(cart);
        var l = find(key); if (l) l._error = false;   /* retry succeeded — clear the sticky error */
        delete pending[key]; busyCount--;
        render();
      }).catch(function () {
        var l = find(key);
        if (l) { l.quantity = prev; l._loading = false; l._error = true; }
        else { CART.items.push(Object.assign({}, line, { quantity: prev, _loading: false, _error: true })); }
        delete pending[key]; busyCount--;
        recalc(); render();
      });
    }, DEBOUNCE);
  }

  /* Add is OPTIMISTIC. Derrick 2026-09-01: "things take forever to get put into
     the cart."

     They did, and the cause was structural rather than slow servers: the old
     version awaited POST /cart/add.js, THEN awaited GET /cart.js, and only opened
     the drawer after both. Two sequential round trips of dead time on every tap,
     which on a throttled in-app browser is most of a second where nothing at all
     happens and the shopper taps again.

     Now the drawer opens on the SAME frame as the tap, showing a provisional line
     built from data the page already has. The network still runs, and the server's
     answer still wins — this shortens the wait, it never fakes the outcome. If the
     request fails the provisional line is removed and the error surfaces. */
  function add(variantId, qty, btn, preview, opts) {
    var n = qty || 1;
    /* `opts.open` decides whether the drawer is thrown on screen. Default true --
       every existing caller relies on it -- but a cart-PAGE add passes false: the
       shopper is already looking at their bag, and sliding a drawer over it is a
       worse answer than updating the page they are reading. The policy travels with
       the call rather than being inferred here, because a queued add resumed by
       pm-atc-guard has to make the same decision from its snapshot. */
    var wantOpen = !(opts && opts.open === false);
    if (btn) { btn.setAttribute('data-busy', 'true'); btn.disabled = true; }

    var tempKey = null;
    if (preview) {
      tempKey = 'pm-pending-' + variantId;
      var existing = find(tempKey);
      if (existing) {
        existing.quantity += n;
      } else {
        CART.items.push({
          key: tempKey, id: Number(variantId), quantity: n,
          product_title: preview.title || '', variant_title: preview.variant || '',
          price: preview.price || 0, final_line_price: (preview.price || 0) * n,
          image: preview.image || '', url: preview.url || '',
          _loading: true, _error: false
        });
      }
      recalc(); render(); if (wantOpen) open();
    }

    return addOnce(Number(variantId), n)
      .then(function (cart) {
        adopt(cart);          /* the server's cart replaces the provisional one wholesale */
        render();
        if (wantOpen) open();  /* no-op when the optimistic path already opened it */
      })
      .catch(function (err) {
        if (tempKey) {
          CART.items = CART.items.filter(function (l) { return l.key !== tempKey; });
          recalc(); render();
        }
        document.dispatchEvent(new CustomEvent('pm:cart:error', { detail: String(err.message || err) }));
      })
      .then(function () { if (btn) { btn.removeAttribute('data-busy'); btn.disabled = false; } });
  }

  /* ---- open / close ---- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = root.querySelector('[data-pm-drawer-close]:not(.pm-drawer__scrim)');
    if (f) f.focus();
  }
  function close() {
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function isOpen() { return root.getAttribute('data-open') === 'true'; }

  document.addEventListener('keydown', function (ev) {
    if (!isOpen()) return;
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });

  root.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t.closest('[data-pm-drawer-close]')) { ev.preventDefault(); close(); return; }
    var line = t.closest('[data-pm-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var cur = find(key); if (!cur) return;
    if (t.closest('[data-pm-qty-dec]')) setQty(key, cur.quantity - 1);
    else if (t.closest('[data-pm-qty-inc]')) setQty(key, cur.quantity + 1);
    else if (t.closest('[data-pm-line-remove]')) setQty(key, 0);
  });

  /* ---- in-cart add-ons ----
     The upsell row is SERVER-RENDERED (Liquid already skips anything in the bag).
     JS only handles the click and re-hides a card once its product is in the cart,
     so nothing here manifests a state that has no HTML equivalent.

     ONE handler, bound to BOTH hosts. It was bound to `root` alone, so the add-on
     rendered on the /cart PAGE was never intercepted at ANY connection speed: the
     click fell through to a real POST and Shopify reloaded the page. That is the
     same half-built-shared-snippet shape as B-047, which the quantity steppers
     below were already fixed for -- the upsell was simply missed. */
  function onUpsellAdd(ev, host) {
    var btn = ev.target.closest('[data-pm-upsell-add]');
    if (!btn) return;
    ev.preventDefault();
    /* Everything the provisional line needs is already on the card, so the add-on
       appears in the bag instantly instead of after two round trips. */
    var li = btn.closest('[data-pm-upsell-item]');
    var img = li && li.querySelector('img');
    var t = li && li.querySelector('.pm-upsell__title');
    var pr = li && li.querySelector('.t-price');
    add(btn.getAttribute('data-pm-upsell-add'), 1, btn, {
      title: t ? t.textContent.trim() : '',
      variant: '',
      price: pr ? Math.round(parseFloat(pr.textContent.replace(/[^0-9.]/g, '')) * 100) || 0 : 0,
      image: img ? img.getAttribute('src') : '',
      url: t ? t.getAttribute('href') : ''
    }, { open: host !== 'page' });
  }
  root.addEventListener('click', function (ev) { onUpsellAdd(ev, 'drawer'); });

  /* ---- the PDP companion piece ----
     Bound to `document`, not to `root`: .pm-pair renders inside the product
     section, outside the drawer. It is a REAL <form action="/cart/add">, so with
     JavaScript off it posts and the shopper lands on /cart with the item added.
     With JS we intercept, add in the background and open the drawer, which keeps
     them on the product page they were already reading. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest('[data-pm-pair-add]');
    if (!f) return;
    ev.preventDefault();
    var id = f.querySelector('input[name="id"]');
    if (!id || !id.value) return;
    var btn = f.querySelector('button');
    var row = f.closest('.pm-pair__row');
    var t = row && row.querySelector('.pm-pair__title');
    var pr = row && row.querySelector('.pm-pair__price');
    var img = row && row.querySelector('img');
    /* Same provisional-line shape the drawer's own add-ons use, so the piece
       appears in the bag immediately rather than after two round trips. */
    add(id.value, 1, btn, {
      title: t ? t.textContent.trim() : '',
      variant: '',
      price: pr ? Math.round(parseFloat(pr.textContent.replace(/[^0-9.]/g, '')) * 100) || 0 : 0,
      image: img ? img.getAttribute('src') : '',
      url: t ? t.getAttribute('href') : ''
    });
  });

  /* Once the companion is in the bag it is no longer a suggestion. Hidden rather
     than removed, so a later removal from the cart brings it back without a
     reload -- and hidden via the [hidden] attribute, which _pm-base.css forces to
     display:none !important precisely because an author `display` rule silently
     outranks the UA one. */
  function syncPair() {
    var pair = document.querySelector('[data-pm-pair]');
    if (!pair) return;
    var f = pair.querySelector('input[name="id"]');
    var link = pair.querySelector('.pm-pair__title');
    if (!link) return;
    var handle = (link.getAttribute('href') || '').split('/products/')[1] || '';
    handle = handle.split('?')[0];
    var present = CART.items.some(function (l) {
      var u = (l.url || '').split('/products/')[1] || '';
      return handle && u.split('?')[0] === handle;
    });
    pair.hidden = present;
  }

  /* ---- re-pick the in-bag add-ons from the co-purchase map ----
     The drawer's add-ons are SERVER-rendered once, at page load, when the bag is
     usually still empty -- so the pair pass has no cart lines to work from and falls
     back to the accessories collection. The shopper then adds a tee, the drawer
     opens, and shows those same generic accessories instead of that tee's partner.
     (The cart PAGE hides this, because navigating to it re-renders with the item
     present. That is why the first test suite passed on a broken drawer.)

     So: after every mutation, resolve each cart line's partner from the map and
     rebuild the list. Falls back to whatever the server rendered if nothing
     resolves, so an add-on row is never empty and JS-off is unaffected. */
  var pairCache = {};
  /* Per-wrapper refresh generation. WeakMap so a wrapper replaced by a re-render
     takes its token with it instead of leaking an entry. */
  var upsellGen = new WeakMap();

  /* The drawer's wrapper and, on /cart, the page's. Both, always -- the whole class
     of bug fixed here is code that looked at one of the two hosts. */
  function upsellWraps() {
    var out = [];
    var a = root.querySelector('[data-pm-upsell]');
    if (a) out.push(a);
    var b = pageRoot && pageRoot.querySelector('[data-pm-upsell]');
    if (b && b !== a) out.push(b);
    return out;
  }

  function upsellMap(wrap) {
    var raw = wrap.getAttribute('data-pm-pair-map') || '';
    var m = {};
    raw.split(',').forEach(function (e) {
      var lr = e.split('>');
      if (lr.length === 2) m[lr[0]] = (lr[1].split(':')[0] || '');
    });
    return m;
  }

  function upsellCard(p, labels) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    var single = (p.variants || []).length === 1 && v;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = (typeof p.price === 'number') ? money(p.price) : '';
    var act = single
      ? '<form action="/cart/add" method="post" enctype="multipart/form-data" class="pm-upsell__form" data-pm-upsell-form>'
        + '<input type="hidden" name="id" value="' + v.id + '">'
        + '<input type="hidden" name="quantity" value="1">'
        + '<button type="submit" class="pm-upsell__btn t-label" data-pm-upsell-add="' + v.id + '">'
        + esc(labels.add) + '<span class="visually-hidden"> — ' + esc(p.title) + '</span>'
        + '</button></form>'
      : '<a class="pm-upsell__btn pm-upsell__btn--link t-label" href="/products/' + p.handle + '">'
        + esc(labels.size) + '<span class="visually-hidden"> — ' + esc(p.title) + '</span></a>';
    return '<li class="pm-upsell__item" data-pm-upsell-item data-product-id="' + p.id + '">'
      + '<a class="pm-upsell__frame" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true">'
      + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="70" loading="lazy">' : '')
      + '</a><div class="pm-upsell__meta">'
      + '<a class="pm-upsell__title t-product" href="/products/' + p.handle + '">' + esc(p.title) + '</a>'
      + '<span class="t-price">' + price + '</span></div>' + act + '</li>';
  }

  function refreshUpsell(wrap) {
    var map = upsellMap(wrap);
    if (!CART.items.length) return;
    var limit = parseInt(wrap.getAttribute('data-pm-upsell-limit') || '2', 10);
    var inBag = {}, want = [];
    CART.items.forEach(function (l) { if (l.handle) inBag[l.handle] = true; });
    CART.items.forEach(function (l) {
      if (want.length >= limit) return;
      var h = map[l.handle];
      if (h && !inBag[h] && want.indexOf(h) === -1) want.push(h);
    });
    if (!want.length) return;                 /* keep the server's fallback row */

    /* Labels come from the server via data attributes. Reading them back out of a
       rendered button with textContent ALSO captures the visually-hidden product
       name inside it, and the next render appends another one -- which is how
       "CHOOSE SIZE" became "CHOOSE SIZE - ORENTHAL LEATHER GLOVES - LAPD TSHIRT",
       overflowed the row, and pushed the cart line's title off screen. */
    var labels = {
      add: wrap.getAttribute('data-pm-add-label') || 'ADD',
      size: wrap.getAttribute('data-pm-size-label') || 'CHOOSE SIZE'
    };

    /* GENERATION TOKEN, PER WRAPPER.
       This fetch is async and its result is written straight into the DOM. Nothing
       cancelled it, so a refresh started before a mutation could land AFTER the next
       one and overwrite freshly-synchronised markup with stale recommendations --
       and it never re-ran the presence pass afterwards, so a row for something now
       in the bag would sit there visible and clickable.
       The token is per wrapper, not global: the drawer and the cart page each hold
       their own upsell wrapper, and one shared counter would have them invalidate
       each other on every single render. */
    var gen = (upsellGen.get(wrap) || 0) + 1;
    upsellGen.set(wrap, gen);

    Promise.all(want.map(function (h) {
      if (pairCache[h]) return Promise.resolve(pairCache[h]);
      return fetch('/products/' + h + '.js', {headers: {Accept: 'application/json'}})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { pairCache[h] = p; return p; })
        .catch(function () { return null; });
    })).then(function (ps) {
      if (upsellGen.get(wrap) !== gen) return;  /* a newer refresh owns this wrapper */
      var good = ps.filter(function (p) { return p && p.available; });
      if (!good.length) return;               /* leave the server row alone */
      var list = wrap.querySelector('.pm-upsell__list');
      if (list) list.innerHTML = good.map(function (p) { return upsellCard(p, labels); }).join('');
      wrap.hidden = false;
      hideOwned(wrap);      /* the replacement is unsynchronised until this runs */
    });
  }

  /* Hide any add-on whose product is already in the bag, and hide the whole block
     when nothing is left to show. Split out of syncUpsell so an async replacement
     can re-run it without re-entering the fetch. */
  function hideOwned(wrap) {
    var ids = {};
    CART.items.forEach(function (l) { if (l.product_id) ids[l.product_id] = true; });
    var left = 0;
    [].forEach.call(wrap.querySelectorAll('[data-pm-upsell-item]'), function (li) {
      var inCart = !!ids[li.getAttribute('data-product-id')];
      li.hidden = inCart;
      if (!inCart) left++;
    });
    /* Hidden when the bag is empty, and when every add-on is already in it — a
       heading with nothing under it is just noise. */
    wrap.hidden = (CART.item_count === 0) || left === 0;
  }

  function syncUpsell() {
    syncPair();
    /* EVERY wrapper, both hosts. This read `root.querySelector(...)` -- the drawer's
       wrapper only -- so on the /cart page the add-on row was never refreshed and
       never hidden once its product was in the bag. */
    [].forEach.call(upsellWraps(), function (wrap) {
      refreshUpsell(wrap);
      hideOwned(wrap);
    });
  }

  root.addEventListener('change', function (ev) {
    var input = ev.target.closest('[data-pm-qty-input]');
    if (!input) return;
    var line = input.closest('[data-pm-line]');
    var n = parseInt(input.value, 10);
    setQty(line.getAttribute('data-key'), isNaN(n) || n < 0 ? 0 : n);
  });

  /* ---- the same handlers, bound to the /cart page ----
     Identical logic, second host. Without these the page's steppers are inert while
     the drawer's work — the exact half-built-shared-snippet shape of B-047. */
  if (pageRoot) {
    /* The add-on. Bound here as well as on the drawer, and with open:false: on the
       cart page the shopper is already reading their bag. */
    pageRoot.addEventListener('click', function (ev) { onUpsellAdd(ev, 'page'); });
    pageRoot.addEventListener('click', function (ev) {
      var line = ev.target.closest('[data-pm-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var cur = find(key); if (!cur) return;
      if (ev.target.closest('[data-pm-qty-dec]')) setQty(key, cur.quantity - 1);
      else if (ev.target.closest('[data-pm-qty-inc]')) setQty(key, cur.quantity + 1);
      else if (ev.target.closest('[data-pm-line-remove]')) setQty(key, 0);
    });
    pageRoot.addEventListener('change', function (ev) {
      var input = ev.target.closest('[data-pm-qty-input]');
      if (!input) return;
      var line = input.closest('[data-pm-line]');
      var n = parseInt(input.value, 10);
      setQty(line.getAttribute('data-key'), isNaN(n) || n < 0 ? 0 : n);
    });

    /* The cart form must NOT submit while JS is driving quantities.
       updates[] is mapped BY CART-LINE ORDER, and JS has already removed lines from
       the server cart, so the positions in a JS-rendered form no longer line up with
       the server's. Submitting would write quantities onto the wrong lines. Enter in
       a number field submits a form by default, so this is reachable by accident.
       Checkout is the one submitter allowed through — it is a real submit button, so
       `disabled` blocks it while a mutation is in flight. `ev.submitter` is not
       available on older WebKit, hence the explicit flag. */
    var allowSubmit = false;
    if (pgCheckout) {
      pgCheckout.addEventListener('click', function () { allowSubmit = true; });
    }
    if (pgForm) {
      pgForm.addEventListener('submit', function (ev) {
        var viaCheckout = allowSubmit ||
          (ev.submitter && ev.submitter.getAttribute('name') === 'checkout');
        allowSubmit = false;
        if (!viaCheckout) ev.preventDefault();
      });
    }
  }

  /* A "disabled" <a> still activates from the keyboard, so the drawer's checkout
     link is guarded here as well as being pulled out of the tab order. */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('.pm-checkout');
    if (a && a.getAttribute('aria-disabled') === 'true') ev.preventDefault();
  }, true);

  /* The bag control is a real <a href="/cart">; JS upgrades it to the drawer.
     [data-pm-bag] is the mockup's header. .cart__toggle is the live theme's —
     it already exists three times (desktop, alt desktop, mobile menu) carrying
     aria-controls="cart-drawer", so the drawer binds to what is there rather
     than the header being rebuilt around it. */
  [].forEach.call(document.querySelectorAll('[data-pm-bag], .cart__toggle'), function (b) {
    b.addEventListener('click', function (ev) { ev.preventDefault(); open(); });
  });

  window.PMCart = { open: open, close: close, add: add, state: function () { return CART; } };
  render();

  /* READINESS IS PUBLISHED LAST, after render() -- not after PMCart is assigned.
     pm-atc-guard resumes a queued tap on this signal, and a resume that lands
     mid-initialisation would add into a drawer that has not painted its own state
     yet. `document.documentElement` rather than a variable, because the guard runs
     before this file does and can only read the DOM. */
  document.documentElement.setAttribute('data-pm-cart-ready', '');
  document.dispatchEvent(new CustomEvent('pm:cart:ready'));
})();


/* ===== navigation prefetch =================================================
   Derrick 2026-09-01: "make everything feel as fast as possible."

   A tap on a product card starts a full page load only AFTER the finger lifts.
   Fetching on touchstart buys the ~90-300ms between press and release, and on a
   slow connection that is the difference between "instant" and "laggy". Desktop
   gets the same on hover, where the lead time is longer still.

   Deliberately conservative:
     * same-origin only, and never the current page
     * NEVER /cart, /checkout or /account — prefetching a stateful or mutating
       route is how you get phantom carts and skewed analytics
     * skipped entirely under Save-Data, and on 2g
     * capped, so a shopper thumbing down 42 cards cannot spawn 42 requests
     * <link rel=prefetch> is a HINT at the lowest priority; it never competes
       with anything the current page still needs
   ========================================================================= */
(function () {
  var c = navigator.connection;
  if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
  try {
    if (!document.createElement('link').relList.supports('prefetch')) return;
  } catch (e) { return; }

  var seen = {}, used = 0, LIMIT = 6;

  function candidate(a) {
    if (!a || !a.getAttribute('href')) return null;
    if (a.hasAttribute('download') || a.target === '_blank') return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (u.pathname === location.pathname) return null;
    if (/^\/(cart|checkout|account|challenge)/.test(u.pathname)) return null;
    return u.href;
  }

  function prefetch(url) {
    if (!url || seen[url] || used >= LIMIT) return;
    seen[url] = 1; used++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function onIntent(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    prefetch(candidate(t.closest('a[href]')));
  }

  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
  document.addEventListener('mouseover', onIntent, { passive: true, capture: true });
})();
